import { render, staticRenderFns } from "./MarkPeople.vue?vue&type=template&id=5b0c619d&"
import script from "./MarkPeople.vue?vue&type=script&lang=js&"
export * from "./MarkPeople.vue?vue&type=script&lang=js&"
import style0 from "./MarkPeople.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports